@if (
  {
    results: (searchParams.results | async) || [],
    isvalid: searchParams.isValid | async,
    messages: searchParams.messages | async,
    cheapest: searchParams.cheapest | async,
    originalUserSearch: searchParams.originalUserSearch,
    fullWidth:
      searchParams.originalUserSearch.chosenSearchType === RailJourneyType.SingleJourney ||
      searchParams.originalUserSearch.chosenSearchType === RailJourneyType.OpenReturnJourney
  };
  as data
) {
  <div class="rail_search_content background-container-background">
    <app-search-toggle [serviceType]="ServiceType.Rail">
      <app-validate-errors [messages]="data.messages"></app-validate-errors>
      <a href="javascript:void(0)" (click)="skipToResultContent()" class="sr-only sr-only-focusable"
        >Skip to result content</a
      >
      <app-rail-search></app-rail-search>
      <div class="flex-row-container flex-row-container--right">
        @if (showDebug) {
          <button appButton="large-search" (click)="alwaysLog(data.results[index])">Dump</button>
        }
        <button
          i18n-title
          appButton="large-search"
          title="Start another search"
          (click)="reSearch()"
          i18n="@@railSearch"
        >
          Search
        </button>
      </div>
    </app-search-toggle>
  </div>
  <app-risk-alerts [countryCode]="'GB'"></app-risk-alerts>
  <div class="flex-row-container carbon_rail_container">
    @if (flightSearchParams.railFromFlightSearchPerformed) {
      <button
        appButton="small"
        class="back-to-button"
        (click)="switchToFlight()"
        i18n="@@backToFlights"
        id="trainlineu-button-back-to-flights"
      >
        <i class="ico-flight" aria-hidden="true"></i>
        Back to flights
      </button>
    }
    @if (flightSearchParams.railFromFlightSearchPerformed) {
      <app-carbon-comparison> </app-carbon-comparison>
    }
  </div>
  @if (
    searchParams.originalUserSearch.chosenSearchType === RailJourneyType.SingleJourney &&
    data.results[index]
  ) {
    <section>
      <div
        appStickyBlock
        [attr.margin]="70"
        [attr.marginFix]="30"
        class="irl-class-header half-container flex-row-container"
      >
        <div class="half-block"></div>
        <div class="half-block flex-row-container">
          <div
            id="fareRulesStand"
            class="irl-class-header_item-class irl-class-header_item-class--2ndclass"
          >
            <span i18n="@@irl2ndclassReturn">2nd class</span>
          </div>
          <div
            id="fareRulesFirst"
            class="irl-class-header_item-class irl-class-header_item-class--1stclass"
          >
            <span i18n="@@irl1stclassrReturn">1st class</span>
            <section class="container"></section>
          </div>
        </div>
      </div>
      @for (item of data.results[index].outbound; track item) {
        <app-trainline-eu-item
          [item]="item"
          [sourceId]="data.results[index].sourceId"
        ></app-trainline-eu-item>
      }
    </section>
  }
  @if (
    searchParams.originalUserSearch.chosenSearchType === RailJourneyType.ReturnJourney &&
    data.results[index]
  ) {
    <section>
      <div
        appStickyBlock
        [attr.margin]="70"
        [attr.marginFix]="30"
        class="irl-class-header half-container flex-row-container"
      >
        <div class="half-block">
          <h3 i18n="@@railEuOutbound">Outbound</h3>
        </div>
        <div class="half-block flex-row-container">
          <div
            id="fareRulesStand"
            class="irl-class-header_item-class irl-class-header_item-class--2ndclass"
          >
            <span i18n="@@irl2ndclassReturn">2nd class</span>
          </div>
          <div
            id="fareRulesFirst"
            class="irl-class-header_item-class irl-class-header_item-class--1stclass"
          >
            <span i18n="@@irl1stclassrReturn">1st class</span>
            <section class="container"></section>
          </div>
        </div>
      </div>
      @for (item of data.results[index].outbound; track item) {
        <app-trainline-eu-item
          [item]="item"
          [type]="RailJourneyType.ReturnJourney"
          [sourceId]="data.results[index].sourceId"
          [clearOutbound]="clearOutbound"
          (fetchInboundTickets)="getInboundSearchResults($event, data.results[index])"
        >
        </app-trainline-eu-item>
      }
    </section>
  }
  @if (
    searchParams.originalUserSearch.chosenSearchType === RailJourneyType.ReturnJourney &&
    inboundResults
  ) {
    <section>
      <div
        appStickyBlock
        [attr.margin]="70"
        [attr.marginFix]="30"
        class="irl-class-header half-container flex-row-container"
      >
        <div class="half-block">
          <h3 i18n="@@railEuInbound">Inbound</h3>
        </div>
        <div class="half-block flex-row-container">
          <div
            id="fareRulesStand"
            alt="For more information regarding the fare conditions select here"
            class="irl-class-header_item-class irl-class-header_item-class--2ndclass"
          >
            <span i18n="@@irl2ndclassReturn">2nd class</span>
          </div>
          <div
            id="fareRulesFirst"
            class="irl-class-header_item-class irl-class-header_item-class--1stclass"
          >
            <span i18n="@@irl1stclassrReturn">1st class</span>
            <section class="container"></section>
          </div>
        </div>
      </div>
      @for (item of inboundResults[0].return; track item) {
        <app-trainline-eu-item
          [item]="item"
          [type]="RailJourneyType.ReturnJourney"
          [sourceId]="data.results[index].sourceId"
          [isInbound]="true"
          (fetchInboundTickets)="getInboundSearchResults($event, data.results[index])"
        >
        </app-trainline-eu-item>
      }
    </section>
  }
  @if (
    data.results.length === 0 ||
    data.results[index]?.outbound.length === 0 ||
    (data.results[index]?.outbound.length === 0 && data.results[index]?.return.length === 0)
  ) {
    <app-no-results></app-no-results>
  }
}
@if (loadingInbound) {
  <app-loading-screen>
    <span title i18n="@@itinerary_LoadingInboundTickets"> Loading inbound tickets... </span>
  </app-loading-screen>
}
